import { getGuest } from './util.js';

let loanObj = null;

const ssfGuest = getGuest();

export const getLoanObject = async () => {
  if (!loanObj) loanObj = await ssfGuest.getObject('Loan');
  return loanObj;
};
